var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocx = function SvgDocx(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 49 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#docx_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.662 46.282h32.571a.86.86 0 0 0 .857-.857V11.997h-7.714a2.575 2.575 0 0 1-2.571-2.572V1.711H13.662a.86.86 0 0 0-.857.857v42.857a.86.86 0 0 0 .857.857"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m45.86 10.285-7.36-7.36v6.503a.86.86 0 0 0 .857.857z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#605E5C",
    fillRule: "evenodd",
    d: "M48.054 10.034 38.773.75a2.6 2.6 0 0 0-1.818-.753h-23.29a2.575 2.575 0 0 0-2.571 2.571v42.858a2.575 2.575 0 0 0 2.571 2.571h32.572a2.575 2.575 0 0 0 2.571-2.571V11.85c0-.686-.267-1.332-.754-1.818m-9.532-7.11 7.36 7.36H39.38a.86.86 0 0 1-.858-.857zm-24.857 43.36h32.572a.86.86 0 0 0 .857-.857V11.998h-7.715a2.575 2.575 0 0 1-2.571-2.571V1.712H13.665a.86.86 0 0 0-.857.857v42.858c0 .473.384.857.857.857",
    clipRule: "evenodd",
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#103F91",
    d: "M41.087 34.285H26.516V36h14.571a.857.857 0 1 0 0-1.714"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185ABD",
    d: "M41.087 29.145H26.516v1.714h14.571a.857.857 0 1 0 0-1.715"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B7CD3",
    d: "M41.087 24H26.516v1.714h14.571a.857.857 0 1 0 0-1.714"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#41A5EE",
    d: "M41.087 18.856H26.516v1.714h14.571a.857.857 0 0 0 0-1.715"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185ABD",
    d: "M3.384 39.428H22.24a2.57 2.57 0 0 0 2.572-2.572V18a2.57 2.57 0 0 0-2.572-2.571H3.384a2.57 2.57 0 0 0-2.571 2.571v18.857a2.57 2.57 0 0 0 2.57 2.572"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F7F7",
    d: "M9.75 32.11h.038c.015-.197 1.942-9.823 1.942-9.823h2.24s1.953 9.177 2.013 9.806h.03c.025-.432 1.618-9.806 1.618-9.806h2.036l-2.506 12H14.78s-1.977-9.48-1.992-9.648h-.03c-.018.194-1.857 9.648-1.857 9.648H8.483l-2.53-12h2.074S9.742 31.9 9.75 32.11"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "docx_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.813-.002h48v48h-48z"
  })))));
};
export default SvgDocx;